import clsx from 'clsx';
import { useContext, useEffect, useState } from 'react';
import Select from 'react-select';
import Icon from 'components/ui/Icon';
import { useTranslation } from 'hooks/useTranslation';
import FilterContext from './filterContext';
import type { APIBeforeAfterPhoto } from 'types/BeforeAfterPhotos';
import type { Slide } from 'types/Utilities';

type Props = {
  isGrid?: boolean;
  slides?: Slide[];
  variant?: 'dark' | 'light';
  onFilterChange?: (value: string) => void;
  updateResultsByTreatment: (option: Record<string, string>) => void;
};

const CarouselFilter = ({
  isGrid = false,
  slides,
  variant = 'dark',
  onFilterChange,
  updateResultsByTreatment,
}: Props): JSX.Element | null => {
  const [treatments, setTreatments] = useState<Record<string, string>[]>([]);
  const { filter } = useContext(FilterContext);
  const { t } = useTranslation();

  useEffect(() => {
    const treatments: Record<string, string>[] = [
      { value: 'All', label: t('treatments.all') },
    ];

    slides?.map((slide: Slide) => {
      if (
        !treatments.some(
          (treatment) =>
            treatment.value ===
            (slide as APIBeforeAfterPhoto).beforeafterphoto?.treatment,
        )
      ) {
        if (
          (slide as APIBeforeAfterPhoto).beforeafterphoto?.treatment as string
        ) {
          treatments.push({
            value: (slide as APIBeforeAfterPhoto).beforeafterphoto
              ?.treatment as string,
            label: (slide as APIBeforeAfterPhoto).beforeafterphoto
              ?.treatment as string,
          });
        }
      }
    });

    // eslint-disable-next-line
    // @ts-ignore
    treatments.sort((a, b) => {
      if (a.value !== 'All') {
        return a.label.localeCompare(b.label);
      }
    });

    setTreatments(treatments);
  }, [slides]);

  useEffect(() => {
    updateResultsByTreatment(filter);
  }, [filter]);

  if (treatments.length <= 2) {
    return null;
  }

  return (
    <div
      className={clsx(
        'w-full ml-6 md:ml-0 md:mr-6 carousel-filter flex items-center justify-end',
        !isGrid && 'hidden md:flex',
      )}
    >
      <div
        className="hidden md:block h-full relative z-9 rounded-md"
        style={{
          backgroundColor: variant === 'dark' ? '' : '#eef2f6',
          padding: '8px',
          marginRight: '-45px',
        }}
      >
        <Icon
          type="FiltersAlternate"
          color={variant === 'dark' ? '#909090' : '#155263'}
        />
      </div>
      <Select
        className={clsx(!isGrid ? 'w-full' : 'w-full md:w-7/12')}
        name="treatmentObject"
        classNamePrefix={variant === 'dark' ? 'tr-dark' : 'tr-light'}
        // eslint-disable-next-line
        // @ts-ignore
        options={treatments || []}
        // eslint-disable-next-line
        // @ts-ignore
        onChange={(option: Record<string, string>) => {
          updateResultsByTreatment(option);
          onFilterChange && onFilterChange(option.value);
        }}
        // eslint-disable-next-line
        // @ts-ignore
        defaultValue={filter || treatments[0]}
      />
    </div>
  );
};

export default CarouselFilter;
